import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Layout } from '../types';

interface LayoutSelectorProps {
  layouts: Layout[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const LayoutSelector: React.FC<LayoutSelectorProps> = ({
  layouts,
  value,
  onChange,
  disabled,
  isLoading,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="layout">Layout</Label>
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled || isLoading}
      >
        <SelectTrigger id="layout">
          <SelectValue placeholder={isLoading ? "Loading..." : "Select a layout"} />
        </SelectTrigger>
        <SelectContent className="max-h-[300px] overflow-y-auto">
          {layouts.map((layout) => (
            <SelectItem key={layout.id} value={layout.id.toString()}>
              {layout.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

